module.exports = __webpack_public_path__ + "static/media/7.8a0aeacc.JPG";